const dayjs = require('dayjs');

export const calculateAge = (dateOfBirth) => {
  const today = dayjs();
  const birthDate = dayjs(dateOfBirth);
  const age = today.diff(birthDate, 'year');

  return age;
};
